export const iconFontAwesomeLogisticsFerry = (
	<i className="fa-solid fa-ferry"></i>
);
